import React from "react";
import moment from "moment";
import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function ReadinessDetails({ sections, readinessData, swmsNumber: displaySwmsNumber, previewMode = false }) {
  const safeSectionData = sections.document_project_details && sections.document_project_details.data || {};
  const readinessSource = readinessData && readinessData.emergency_readiness
    ? readinessData.emergency_readiness
    : (readinessData && readinessData.document ? readinessData.document : readinessData);
  const readinessQuestions = readinessSource
    && typeof readinessSource === "object"
    && readinessSource.rescue_readiness_questions
    ? readinessSource.rescue_readiness_questions
    : (readinessSource && typeof readinessSource === "object" ? readinessSource : {});
  const safeReadinessQuestions = readinessQuestions && typeof readinessQuestions === "object"
    ? readinessQuestions
    : {};
  const readinessPlans = Array.isArray(safeReadinessQuestions.plans)
    ? safeReadinessQuestions.plans.filter((plan) => plan && plan.disabled !== true)
    : [];
  const emergencyPlanNumbers = readinessPlans
    .map((plan) => plan.document_number)
    .filter(Boolean)
    .join("; ");
  const applicableProcedureNumbers = readinessPlans
    .flatMap((plan) => (Array.isArray(plan.linked_documents) ? plan.linked_documents : []))
    .filter((document) => document && document.checked === true && document.disabled !== true)
    .map((document) => document.document_number)
    .filter(Boolean)
    .join("; ");
  const swmsNumber = displaySwmsNumber || safeSectionData.swms_number || "";
  const readinessNumber = swmsNumber ? `${swmsNumber}-RDY` : "";
  const shiftId = safeReadinessQuestions.shift_id;
  const readinessDate = safeReadinessQuestions.readiness_date
    ? moment.utc(safeReadinessQuestions.readiness_date).format("DD/MM/YYYY")
    : "";
  const status = previewMode
    ? (String(readinessData && readinessData.status).toUpperCase() === "APPROVED" ? "Approved" : "Pending")
    : "Approved";
  const supervisorDetails = safeReadinessQuestions.shift_answers
    && safeReadinessQuestions.shift_answers.supervisor_submission
    ? safeReadinessQuestions.shift_answers.supervisor_submission
    : {};

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.readinessSectionNum}`}>1</span>
        Rescue Readiness Details
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewSectionSubHead}>Record Identity</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Readiness Checklist Id</span>
                <span className={styles.PreviewValue}>{readinessNumber || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Shift ID</span>
                <span className={styles.PreviewValue}>{shiftId || (previewMode ? "{shift}" : "")}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Readiness Date</span>
                <span className={styles.PreviewValue}>{readinessDate || (previewMode ? "{date}" : "")}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Status</span>
                <span className={styles.PreviewValue}>{status}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={styles.PreviewSectionSubHead}>Linked Documents &amp; Work Context</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Linked SWMS</span>
                <span className={styles.PreviewValue}>{safeSectionData.swms_number || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Emergency Plan</span>
                <span className={styles.PreviewValue}>
                  {previewMode
                    ? (swmsNumber ? `${swmsNumber}-ERP` : <span>&mdash;</span>)
                    : (emergencyPlanNumbers || <span>&mdash;</span>)}
                </span>
              </td>
              <td colSpan={2}>
                <span className={styles.PreviewLabel}>Applicable Procedures</span>
                <span className={styles.PreviewValue}>
                  {previewMode
                    ? (swmsNumber ? `${swmsNumber}-PRO` : <span>&mdash;</span>)
                    : (applicableProcedureNumbers || <span>&mdash;</span>)}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={styles.PreviewSectionSubHead}>Shift Context</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Site Name</span>
                <span className={styles.PreviewValue}>{safeSectionData.site_name || <span>&mdash;</span>}</span>
              </td>
              <td colSpan={2}>
                <span className={styles.PreviewLabel}>Site Address</span>
                <span className={styles.PreviewValue}>{safeSectionData.site_address || <span>&mdash;</span>}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Supervisor</span>
                <span className={styles.PreviewValue}>{supervisorDetails.staff_name || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Position</span>
                <span className={styles.PreviewValue}>{supervisorDetails.job_title || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Phone</span>
                <span className={styles.PreviewValue}>{supervisorDetails.phone_number || <span>&mdash;</span>}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
